import React, { useState, useEffect } from "react";
import {
  IconButton, Tooltip, Grid, Dialog, DialogTitle, DialogActions,
  DialogContent, Button, Typography, Divider, Alert, List, ListItemButton,
  ListItemText, Checkbox, CardHeader, Card, ListItemIcon, Box, CircularProgress
} from "@mui/material";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import SearchField from "react-search-field";

export default function App({ labtype, InstanceID, count, is_userassign }) {
  const [formFieldsToAdd, setformFieldsToAdd] = useState([]);
  const [traineeuserlist, setTraineeuserlist] = useState([]);
  const [open, setOpen] = useState(false);
  const [assignSuccessOpen, setAssignSuccessOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [searchitems, setSearchItems] = useState("");
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [checked, setChecked] = useState([]);

  // Fetch Trainee Users
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/traineeuserlistView/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then(setTraineeuserlist)
      .catch(() => (window.location.href = "/something_went_wrong"));
  }, []);

  useEffect(() => {
    setLeft(traineeuserlist.map((t, index) => ({ id: index, email: t.email })));
  }, [traineeuserlist]);

  const handleAddForm = () => {
    setOpen(true);
    const collectType = Array.from({ length: count }, (_, i) => ({ id: i, email: "" }));
    setformFieldsToAdd(collectType);
  };

  const handleClose = () => {
    setOpen(false);
    setValidationError("");
    setErrorMessage("");
  };

  const handleAssignSuccessClose = () => {
    setAssignSuccessOpen(false);
    window.location.reload();
  };

  // Helper Functions
  const not = (a, b) => a.filter((value) => b.indexOf(value) === -1);
  const intersection = (a, b) => a.filter((value) => b.indexOf(value) !== -1);
  const union = (a, b) => [...a, ...not(b, a)];

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);
  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    currentIndex === -1 ? newChecked.push(value) : newChecked.splice(currentIndex, 1);
    setChecked(newChecked);
  };

  const handleToggleAll = (items) => () => {
    numberOfChecked(items) === items.length
      ? setChecked(not(checked, items))
      : setChecked(union(checked, items));
  };

  const handleAddToRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleAddToLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const filteredLeftList = left.filter((instance) =>
    instance.email.toLowerCase().includes(searchitems.toLowerCase())
  );

  // Submit Handler
  const handleSubmitClick = (e) => {
    e.preventDefault();
    let hasDuplicates = false;

    for (let i = 0; i < rightChecked.length; i++) {
      for (let j = i + 1; j < rightChecked.length; j++) {
        if (rightChecked[i].email === rightChecked[j].email) {
          hasDuplicates = true;
          break;
        }
      }
      if (hasDuplicates) break;
    }

    if (hasDuplicates) {
      setDialogOpen(true);
      return;
    }

    const data = {
      lab_id: InstanceID,
      lab_type: labtype,
      details: rightChecked,
    };

    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/crtusrndasslb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code === 500) setValidationError(data.message);
        else {
          setAssignSuccessOpen(true);
          setOpen(false);
        }
      })
      .catch(() => {
        setLoading(false);
        setErrorMessage("Something Went Wrong");
      });
  };

  return (
    <div>
      <Tooltip title={is_userassign === "yes" ? "Already assigned" : "Assign Users"} arrow>
        <span>
          <IconButton
            aria-label="add"
            onClick={handleAddForm}
            disabled={is_userassign === "yes"}
          >
            <LibraryAddIcon color={is_userassign === "yes" ? "" : "primary"} />
          </IconButton>
        </span>
      </Tooltip>

      {/* Duplicate Email Alert */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Notification</DialogTitle>
        <DialogContent>
          <Typography>Same Email IDs selected. Please choose different ones.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} variant="contained" sx={{ borderRadius: "20px" }}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* Success Notification */}
      <Dialog open={assignSuccessOpen} onClose={handleAssignSuccessClose}>
        <DialogTitle>Notification</DialogTitle>
        <DialogContent>
          <Typography>Trainee has been assigned successfully.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAssignSuccessClose} variant="contained" sx={{ borderRadius: "20px" }}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* Main Assign Dialog */}
      <Dialog fullWidth open={open} maxWidth="md" onClose={handleClose}>
        <DialogTitle sx={{ textAlign: "center" }} fontWeight="bold" fontSize={{ xs: "1.25rem", sm: "1.5rem" }}>ASSIGN USERS</DialogTitle>
        <DialogContent dividers>
          {validationError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              <Typography variant="body1">{validationError}</Typography>
            </Alert>
          )}

          {/* Header Row with Centered Text and Search on Same Line */}
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 2 }}
          >
            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  textAlign: "center",
                  width: "100%",
                }}
              >
                Trainee to be assigned: {formFieldsToAdd.length}
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <SearchField
                  value={searchitems}
                  placeholder="Search by Email ID"
                  onChange={(event) => setSearchItems(event)}
                />
              </Box>
            </Grid>
          </Grid>


          {/* Transfer Lists */}
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <Card>
                <CardHeader
                  title="Select Trainees"
                  subheader={`${numberOfChecked(left)}/${left.length} selected`}
                  avatar={
                    <Checkbox
                      onClick={handleToggleAll(left)}
                      checked={numberOfChecked(left) === left.length && left.length !== 0}
                      indeterminate={
                        numberOfChecked(left) !== left.length && numberOfChecked(left) !== 0
                      }
                      disabled={left.length === 0}
                    />
                  }
                />
                <Divider />
                <List dense component="div">
                  {filteredLeftList.map((trainee) => (
                    <ListItemButton key={trainee.id} onClick={handleToggle(trainee)}>
                      <ListItemIcon>
                        <Checkbox checked={checked.indexOf(trainee) !== -1} />
                      </ListItemIcon>
                      <ListItemText primary={trainee.email} />
                    </ListItemButton>
                  ))}
                </List>
              </Card>
            </Grid>

            {/* Move Buttons */}
            <Grid item xs={2}>
              <Grid container direction="column" alignItems="center" justifyContent="center" spacing={1}>
                <Grid item>
                  <Tooltip title="Move right" arrow>
                    <span>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleAddToRight}
                        disabled={
                          leftChecked.length === 0 ||
                          right.length + leftChecked.length > formFieldsToAdd.length
                        }
                        sx={{ borderRadius: "50%", minWidth: 36 }}
                      >
                        &gt;
                      </Button>
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title="Move left" arrow>
                    <span>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleAddToLeft}
                        disabled={rightChecked.length === 0}
                        sx={{ borderRadius: "50%", minWidth: 36 }}
                      >
                        &lt;
                      </Button>
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={5}>
              <Card>
                <CardHeader
                  title="Selected Trainees"
                  subheader={`${numberOfChecked(right)}/${right.length}`}
                  avatar={
                    <Checkbox
                      onClick={handleToggleAll(right)}
                      checked={numberOfChecked(right) === right.length && right.length !== 0}
                      indeterminate={
                        numberOfChecked(right) !== right.length && numberOfChecked(right) !== 0
                      }
                      disabled={right.length === 0}
                    />
                  }
                />
                <Divider />
                <List dense component="div">
                  {right.map((trainee) => (
                    <ListItemButton key={trainee.id} onClick={handleToggle(trainee)}>
                      <ListItemIcon>
                        <Checkbox checked={checked.indexOf(trainee) !== -1} />
                      </ListItemIcon>
                      <ListItemText primary={trainee.email} />
                    </ListItemButton>
                  ))}
                </List>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", mt: 2 }}>
          <Tooltip title="Cancel" arrow>  
            <span>
            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              disabled={loading} // Disable Cancel while Assign is processing
              sx={{ borderRadius: "20px", px: 3 }}
            >
              Cancel
            </Button>
            </span> 
          </Tooltip>
          <Tooltip title="Assign" arrow>
            <span>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmitClick}
              disabled={
                rightChecked.length !== formFieldsToAdd.length || loading
              }
              sx={{ borderRadius: "20px", px: 3 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Assign"}
            </Button> 
            </span>
          </Tooltip>
        </DialogActions>

      </Dialog>
    </div>
  );
}
